import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "flex-row justify-center m-5" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "flex m-5"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 1,
  class: "flex m-5"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", {
  class: "text-black transition-colors uppercase h-11 w-full font-semibold tracking-widest bg-primary-600",
  disabled: ""
}, " Voto registrado ", -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 0,
  class: "popup-iframe fixed flex inset-0 transition delay-150 duration-300 ease-in-out"
}
const _hoisted_11 = {
  key: 0,
  class: "relative m-auto z-40"
}
const _hoisted_12 = {
  key: 0,
  class: "absolute inset-0 m-auto z-50"
}
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"w-full h-full bg-gray-900 rounded-lg sahdow-lg p-6 flex flex-col justify-center items-center\"><div><div class=\"text-primary mb-4\"><svg class=\"w-6 sm:w-24 h-6 sm:h-24 m-auto\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z\"></path></svg></div><h3 class=\"text-lg text-white\">Voto computado com sucesso!</h3></div></div>", 1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "w-full bg-gray-900 rounded-lg sahdow-lg p-6 flex flex-col justify-center items-center" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-xl text-white font-semibold" }, "Nome:")
], -1)
const _hoisted_17 = { class: "text-center w-full" }
const _hoisted_18 = { class: "relative mb-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-xl text-white font-semibold" }, "Email:")
], -1)
const _hoisted_20 = { class: "text-center w-full" }
const _hoisted_21 = { class: "relative mb-4" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-xl text-white font-semibold" }, " Por que esse gol marcou na minha memoria? ")
], -1)
const _hoisted_23 = { class: "text-center w-full" }
const _hoisted_24 = { class: "relative mb-4" }
const _hoisted_25 = { class: "absolute px-2 py-1 text-xs text-gray-400 rounded right-2 bottom-2" }
const _hoisted_26 = { class: "block text-sm text-white mb-4 text-left" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Estou apto/interessado a gravar a narração do gol em um dia combinado. ")
const _hoisted_28 = { class: "mb-4" }
const _hoisted_29 = {
  key: 0,
  class: "text-xl text-white font-semibold"
}
const _hoisted_30 = {
  key: 0,
  class: "text-center w-full"
}
const _hoisted_31 = { class: "relative mb-4" }
const _hoisted_32 = {
  key: 1,
  class: "relative m-auto z-40",
  width: "560",
  height: "315",
  src: "https://www.youtube.com/embed/mNRSBiXDn5A",
  title: "YouTube video player",
  frameborder: "0",
  allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
  allowfullscreen: ""
}
const _hoisted_33 = {
  key: 2,
  class: "relative m-auto z-40",
  width: "560",
  height: "315",
  src: "https://www.youtube.com/embed/xgVpGQD2M9Y",
  title: "YouTube video player",
  frameborder: "0",
  allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
  allowfullscreen: ""
}
const _hoisted_34 = {
  key: 3,
  class: "relative m-auto z-40",
  width: "560",
  height: "315",
  src: "https://www.youtube.com/embed/I7yHTEwbqp4",
  title: "YouTube video player",
  frameborder: "0",
  allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
  allowfullscreen: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_slide = _resolveComponent("slide")!
  const _component_navigation = _resolveComponent("navigation")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_carousel = _resolveComponent("carousel")!
  const _component_text_field = _resolveComponent("text-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_carousel, {
      "items-to-show": 3.5,
      wrapAround: true,
      breakpoints: _ctx.breakpoints
    }, {
      addons: _withCtx(() => [
        _createVNode(_component_navigation),
        _createVNode(_component_pagination)
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videos, (slide) => {
          return (_openBlock(), _createBlock(_component_slide, { key: slide }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("span", null, [
                  _createElementVNode("img", {
                    src: slide.thumbnail
                  }, null, 8, _hoisted_3)
                ]),
                (!this.voteSuccess)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.showModal(slide.iframe)),
                        class: "text-black bg-white hover:bg-gray-200 transition-colors uppercase h-11 w-full font-semibold tracking-widest"
                      }, " Ver lance ", 8, _hoisted_5),
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.showVoteModal(slide.id)),
                        class: "text-black hover:bg-primary-600 transition-colors uppercase h-11 w-full font-semibold tracking-widest bg-primary ml-4"
                      }, " Votar ", 8, _hoisted_6)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
              ])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["items-to-show", "breakpoints"]),
    (_ctx.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_ctx.voteModal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_ctx.voteSuccess)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_text_field, {
                        modelValue: _ctx.formVote.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.formVote.name = $event)),
                        name: "name",
                        required: "",
                        error: _ctx.errors.name
                      }, null, 8, ["modelValue", "error"])
                    ])
                  ]),
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_text_field, {
                        modelValue: _ctx.formVote.email,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formVote.email = $event)),
                        name: "email",
                        required: "",
                        error: _ctx.errors.email,
                        onBlur: _ctx.validateEmail
                      }, null, 8, ["modelValue", "error", "onBlur"])
                    ])
                  ]),
                  _hoisted_22,
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("textarea", {
                        onKeyup: _cache[2] || (_cache[2] = ($event: any) => (_ctx.countChars($event.target.value))),
                        rows: "4",
                        maxlength: "300",
                        class: "block w-full mt-1 py-2 px-3 rounded-md shadow-sm focus:outline-none"
                      }, null, 32),
                      _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.curChar), 1)
                    ]),
                    _createElementVNode("label", _hoisted_26, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        class: "mr-2",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formVote.accept = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.formVote.accept]
                      ]),
                      _hoisted_27
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      (_ctx.formVote.accept)
                        ? (_openBlock(), _createElementBlock("h3", _hoisted_29, " Telefone: "))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.formVote.accept)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _createVNode(_component_text_field, {
                              modelValue: _ctx.formVote.Phone,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formVote.Phone = $event)),
                              name: "Phone",
                              required: "",
                              error: _ctx.errors.phone
                            }, null, 8, ["modelValue", "error"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.voteThis())),
                      class: "text-black hover:bg-primary-600 transition-colors uppercase h-6 md:h-12 w-full font-semibold tracking-widest bg-primary"
                    }, " Votar ")
                  ])
                ])
              ]))
            : (
          _ctx.linkIframe.trim() === 'https://www.youtube.com/embed/mNRSBiXDn5A'
        )
              ? (_openBlock(), _createElementBlock("iframe", _hoisted_32))
              : (
          _ctx.linkIframe.trim() === 'https://www.youtube.com/embed/xgVpGQD2M9Y'
        )
                ? (_openBlock(), _createElementBlock("iframe", _hoisted_33))
                : (
          _ctx.linkIframe.trim() === 'https://www.youtube.com/embed/I7yHTEwbqp4'
        )
                  ? (_openBlock(), _createElementBlock("iframe", _hoisted_34))
                  : _createCommentVNode("", true),
          _createElementVNode("span", {
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
            class: "absolute inset-0 opacity-70 bg-black"
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}